module.exports = __webpack_public_path__ + "img/Partner_05.0c1786a5.png";